import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';

export class FormattedMessage extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      parts: `json`,
    };
  }

  get config() {
    return {
      template,
    };
  }
}

export const FormattedMessageEl = defineAndMakeJsxFactory(`mp-formatted-message`, FormattedMessage);
